import React from 'react';
import { AddFilterButton } from './AddFilterButton';
import { SegmentSelect } from './SegmentSelect';
import { ToggleFiltersButton } from './ToggleFiltersButton';
import { ApplicationListingFilters, FilterType } from '../utils';
import { SearchSegment } from '../../../../../../../entities/v1/applicant_tracking/SearchSegment';
import { getQueryParam } from '../../../../../../../utils/url';
import { SEARCH_PARAM, decodeSearchQuery } from '../../../OpenSearch';

interface PropTypes {
  atsTagsPanelEnabled: boolean;
  atsApplicationFormFilterEnabled: boolean;
  atsInterviewContentFilterEnabled: boolean;
  atsJobStatusFilterEnabled: boolean;
  isFiltersOpen: boolean;
  filters: ApplicationListingFilters;
  filterTypes: FilterType[];
  segments: SearchSegment[];
  selectedSegment: SearchSegment;
  setIsFiltersOpen: (value: boolean) => void;
  setFilterTypes: (filterTypes: FilterType[]) => void;
  setSelectedSegment: (segment: SearchSegment) => void;
  setFilters: (filters: ApplicationListingFilters) => void;
}

export function FiltersHeader(props: PropTypes) {
  // Decode the search parameter when reading from URL (required due to security feature)
  const encodedSearch = getQueryParam(SEARCH_PARAM);
  const decodedSearch = decodeSearchQuery(encodedSearch);

  return (
    <div className='d-flex justify-content-between'>
      <AddFilterButton
        atsTagsPanelEnabled={props.atsTagsPanelEnabled}
        atsApplicationFormFilterEnabled={props.atsApplicationFormFilterEnabled}
        atsInterviewContentFilterEnabled={
          props.atsInterviewContentFilterEnabled
        }
        atsJobStatusFilterEnabled={props.atsJobStatusFilterEnabled}
        filterTypes={props.filterTypes}
        filters={props.filters}
        setFilters={props.setFilters}
        setFilterTypes={props.setFilterTypes}
        setIsFiltersOpen={props.setIsFiltersOpen}
      />
      <div className='d-flex gap-3 align-items-center'>
        {decodedSearch && (
          <span className='fs-5'>
            Showing results for <b>&quot;{decodedSearch}&quot;</b>
          </span>
        )}
        <ToggleFiltersButton
          filters={props.filters}
          isFiltersOpen={props.isFiltersOpen}
          setIsFiltersOpen={props.setIsFiltersOpen}
        />
        <SegmentSelect
          segments={props.segments}
          selectedSegment={props.selectedSegment}
          setSelectedSegment={props.setSelectedSegment}
        />
      </div>
    </div>
  );
}
